import { Component, OnInit } from '@angular/core';
import {DoraDataGridSelectorComponent} from '../dora-data-grid-selector.component';
import {DataRow} from '../../../DoraData/data-row';
import {DataTupla} from '../../../DoraData/data-tupla';
import {log} from 'util';

@Component({
  selector: 'dora-data-grid-selector-tab-scroll',
  templateUrl: './dora-data-grid-selector-tab-scroll.component.html',
  styleUrls: ['./dora-data-grid-selector-tab-scroll.component.scss']
})
export class DoraDataGridSelectorTabScrollComponent extends DoraDataGridSelectorComponent {

  private startTab = 0;


  protected onNewData(): void {
    super.onNewData();
    this.startTab = 0;
  }

  public onSelect(rowIndex: number, dataRow: DataRow): void {
    this.selectedGrid(dataRow.Id);
  }

  // Methods for Css Class
  public getElementContainerCssClass(rowIndex: number, dataRow: DataRow): string {
    let result: string;

    result = 'tab-element-container ' + dataRow.CssFormat;
    result += (dataRow.selected) ? ' on' : ' off';

    return result;
  }
  public getElementContentCssClass(rowIndex: number, dataRow: DataRow): string {
    return 'tab-element-content';
  }

  public getElementContent(rowIndex: number, dataRow: DataRow): string {
    let result = '';
    const descriptionTupla: DataTupla = dataRow.getDataTupla('Description');
    if (descriptionTupla !== undefined) {
      result = descriptionTupla.Value;
    }
    return result;
  }

  public getBtnLeftCssClass(): string {
    let result = '';

    result = 'DAG-btn DAG-btn-left ' + ((this.startTab === 0) ? 'off' : 'on');
    return result;
  }

  public getBtnRightCssClass(): string {
    let result = '';

    result = 'DAG-btn DAG-btn-right ' + ((this.startTab === this.getHtmlTabs().length - 1) ? 'off' : 'on');
    return result;
  }

  public onRight(): void {
    if (this.startTab < this.getHtmlTabs().length - 1) {
      this.startTab++;
    }
  }

  public onLeft(): void {
    if (this.startTab > 0) {
      this.startTab--;
    }
  }

  private setOffsetToInternal(): string {
    const myLeft = this.getHtmlTabOffset(this.startTab);
    return myLeft;
  }
  private getHtmlTabs(): HTMLCollectionOf<Element> {
    // tslint:disable-next-line:max-line-length
    return (this.elementRef.nativeElement as HTMLElement).getElementsByClassName('tab-element-container-external');

  }

  private getHtmlTabOffset(idx: number): string {
    const htmlTabs: HTMLCollectionOf<Element> = this.getHtmlTabs();
    if (idx >= htmlTabs.length) {
      return '0px';
    }

    let myWidth = 0;
    for (let i = 0; i < idx; i++) {
      myWidth += htmlTabs.item(i).clientWidth;
    }
    const result = '-' + myWidth.toString() + 'px';
    return result;
  }
}
